import {useState, useEffect} from 'react';
import {ImageBackground, View} from 'react-native';
import config from '~/configuration';

const DealerPersona = ({dealer_id, company_name, fallback, size = 32}) => {
  const height = size;
  const width = size;

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      if (dealer_id) {
        const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${company_name}.svg`;
        setImage(image_url);
        setLoading(true);
      } else {
        setLoading(false);
      }
    };

    retrieve();
  }, [dealer_id]);

  return image ? (
    <View
      style={{
        visibility: loading ? 'hidden' : 'visible',
      }}>
      <img
        src={image}
        style={{width, height}}
        alt={company_name}
        onLoad={() => {
          setLoading(false);
        }}
        onError={() => {
          setImage(null);
          setLoading(false);
        }}
      />
    </View>
  ) : loading ? (
    <View style={{width, height}}></View>
  ) : (
    fallback ?? (
      <View
        style={[
          {
            borderRadius: 50,
            overflow: 'hidden',
            width,
            height,
          },
        ]}>
        <ImageBackground
          style={{width, height}}
          source={{
            uri: `${config.publicApiRoot}/dealer/photo/${dealer_id}`,
          }}
        />
      </View>
    )
  );
};

export default DealerPersona;
